/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Special Product Restrictions
 */
export var ProductSpecialRestrictionCode;
(function (ProductSpecialRestrictionCode) {
    ProductSpecialRestrictionCode["QUALITY"] = "QUALITY";
    ProductSpecialRestrictionCode["CUSTOMER"] = "CUSTOMER";
    ProductSpecialRestrictionCode["DISCONTIN"] = "DISCONTIN";
    ProductSpecialRestrictionCode["PRERELEASE"] = "PRERELEASE";
    ProductSpecialRestrictionCode["UNIT_TEST"] = "UNIT TEST";
})(ProductSpecialRestrictionCode || (ProductSpecialRestrictionCode = {}));
